export const nItemData = [
  {
    imgSrc:"./images/main/new/new_01.jpg",
    cateName:"척테일러",
    itemName:"척테일러 올스타 무브 플랫폼 스티키 알로에",
    itemPrice:"65,000"
  },
  {
    imgSrc:"./images/main/new/new_02.jpg",
    cateName:"런스타",
    itemName:"런스타 레거시 CX 플랫폼 토탈리 뉴트럴",
    itemPrice:"125,000"
  },
  {
    imgSrc:"./images/main/new/new_03.jpg",
    cateName:"척70",
    itemName:"척70 시즈널 컬러 다크 루트",
    itemPrice:"95,000"
  },
  {
    imgSrc:"./images/main/new/new_04.jpg",
    cateName:"척70",
    itemName:"척70 시즈널 컬러 다크 루트",
    itemPrice:"99,000"
  },
  {
    imgSrc:"./images/main/new/new_05.jpg",
    cateName:"척테일러",
    itemName:"척테일러 올스타 크루즈 클라우디 데이즈",
    itemPrice:"89,000"
  },
  {
    imgSrc:"./images/main/new/new_06.jpg",
    cateName:"척테일러",
    itemName:"척테일러 올스타 시티 트렉 타우니 아울",
    itemPrice:"95,000"
  },
  {
    imgSrc:"./images/main/new/new_07.jpg",
    cateName:"척테일러",
    itemName:"척테일러 올스타 시티 트렉 코스믹 터틀",
    itemPrice:"95,000"
  },
  {
    imgSrc:"./images/main/new/new_08.jpg",
    cateName:"런스타",
    itemName:"런스타 레거시 CX 플랫폼 찬스 오브 레인",
    itemPrice:"125,000"
  },
];